import { api } from "@/api/client";

export interface MeResponse {
  user: { id: string; email: string; created_at: string; role: "user" | "admin" };
  memberships: Array<{
    project_id: string;
    name: string;
    plan_id: string;
    role: "owner" | "developer" | "billing";
  }>;
  pending_intent: {
    payment_id: string;
    intent_name: string;
    created_at: string;
  } | null;
}

export interface SessionRow {
  id: string;
  user_agent: string | null;
  ip: string | null;
  country: string | null;
  issued_at: string;
  expires_at: string;
  current: boolean;
}

export const meApi = {
  get: () => api.get<MeResponse>("/me"),
  sessions: () => api.get<SessionRow[]>("/sessions"),
  revokeSession: (sid: string) => api.delete<{ ok: true }>(`/sessions/${sid}`),
};
